<div
  class="relative mt-20 flex w-[487px] flex-col gap-4 rounded-4xl bg-background-card p-6 shadow-modal"
  [formGroup]="perioSettingsModalForm"
>
  <div class="mx-3 my-2">
    <p class="typo-h2 text-center text-text-primary">{{ 'perio_exam_settings_modal_title' | translate }}</p>
    <button class="absolute right-6 top-8" (click)="onCancelClick()">
      <svg-icon class="text-text-primary" key="px-24-x" size="md"></svg-icon>
    </button>
  </div>
  <div class="rounded-[40px] bg-background-card p-6">
    <lib-perio-exam-direction-carousel
      [perioExamDirections]="mockPerioExamDirections"
      [selectedPerioExamDirectionId]="traversalStrategy()"
      (perioExamDirectionSelected)="onPerioExamTraversalStrategySelected($event)"
    />
    <div class="my-4 h-[1px] bg-background-disabled"></div>

    <div class="flex flex-col gap-4">
      <div class="flex h-10 items-center justify-between">
        <div>
          <p class="typo-h4-light text-text-tertiary">{{ 'perio_exam_settings_modal_recession_input' | translate }}</p>
          <p class="typo-h7-light text-text-primary">{{ 'perio_exam_settings_modal_recession_input_subtitle' | translate }}</p>
        </div>
        <lib-button-group>
          @for (option of recessionInputOptions; track option.value) {
            <lib-button-group-element
              [active]="perioSettingsModalForm.controls.recessionInputType.value === option.value"
              (click)="onRecessionInputTypeChange(option.value)"
            >
              {{ option.labelKey | translate }}
            </lib-button-group-element>
          }
        </lib-button-group>
      </div>
      <div class="flex h-10 items-center justify-between">
        <p class="typo-h4-light text-text-tertiary">{{ 'perio_exam_settings_modal_missing_teeth' | translate }}</p>
        <button class="btn-text text-h5 font-semibold text-primary-blue" (click)="openMissingToothModal()">
          {{ 'perio_exam_settings_modal_identify_missing_teeth_label' | translate }}
          <svg-icon key="px-16-arrow-right" class="text-text-black"></svg-icon>
        </button>
      </div>
      <div class="flex h-10 items-center justify-between">
        <p class="typo-h4-light text-text-tertiary">{{ 'perio_exam_settings_modal_provider' | translate }}</p>
        <lib-select-provider
          class="block"
          [defaultValue]="perioSettingsModalForm.controls.provider.value"
          [showBorderAlways]="true"
          (itemSelected)="onProviderChange($event)"
        />
      </div>
    </div>
  </div>
  <div class="flex w-full justify-end gap-10">
    <button class="btn-text" (click)="onCancelClick()">{{ 'perio_exam_settings_modal_cancel' | translate }}</button>
    <button class="btn-primary" (click)="onSaveClick()">{{ getSaveButtonTranslationKey() | translate }}</button>
  </div>
</div>
